import React from 'react'
import DateRangePicker from './DateRangePicker'

const RevenueSelectOptions = () => {
    return (
        <div className='d-flex justify-content-between revenue_select '>
            <div>
                <select className="form-select form-select-sm  bg-base border text-secondary-light" defaultValue="State Wise">
                    <option value="State">State Wise</option>
                    <option value="Manager">Manager Wise</option>
                    <option value="Center">Center Wise</option>

                </select>
            </div>
            <div>
                <select className="form-select form-select-sm  bg-base border text-secondary-light" defaultValue="Owner">
                    <option value="Owner">Owner</option>
                    <option value="Partnership">Partnership</option>
                    <option value="Franchise">Franchise</option>

                </select>
            </div>
            <div className=" date_picker_inpur">
                <DateRangePicker />
            </div>

            <div>
                <button
                    type="button"
                    className="btn btn-info-600 radius-8 px-10 py-7"
                >
                    Go
                </button>
            </div>

        </div>
    )
}

export default RevenueSelectOptions